import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinus, faPlus} from "@fortawesome/free-solid-svg-icons";
import {handleLog} from "../logger.helper";

interface VakgebiedFilterProps {
    vakgebieden: string[];
    activeFilters: string[];
    setFilters: (vakgebieden: string[]) => void;
}

const VakgebiedFilter: React.FC<VakgebiedFilterProps> = ({vakgebieden, activeFilters, setFilters}) => {

    const [isActive, setIsActive] = useState(false);

    const handleToggle = () => {
        setIsActive(!isActive);
    };

    const onCheckClick = (vakgebied, isChecked) => {
        handleLog("Clickrate_FilterVakgebied", "Vacatures", "Clickrate_FilterVakgebied");
        let copy = [...activeFilters];
        if (isChecked) {
            copy.push(vakgebied);
        } else {
            const index = copy.indexOf(vakgebied);
            if (index > -1) {
                copy.splice(index, 1);
            }
        }
        setFilters(copy);
    };

    return (
        <>
            <h4 onClick={handleToggle} className="text-heading-6 color-green-900 pointer">
                <FontAwesomeIcon className='font-xs' icon={isActive ? faMinus : faPlus}/>
                {" "}
                Vakgebied
            </h4>
            <div className={isActive ? "show" : "collapse"}>
                <ul className="list-type">
                    {vakgebieden.map((vakgebied) => (
                        <li key={vakgebied}>
                            <div className='d-flex align-items-center'>
                                <input className="form-check-input mr-10 custom-checkbox" type="checkbox"
                                       checked={activeFilters.includes(vakgebied)}
                                       onChange={(e) => onCheckClick(vakgebied, e.target.checked)}/>
                                <span onClick={() => onCheckClick(vakgebied, !activeFilters.includes(vakgebied))}
                                      className="btn btn-link p-0">{vakgebied}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default VakgebiedFilter;
